import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Button } from 'reactstrap';
import { pluck } from 'underscore';
import { v4 as uuidV4 } from 'uuid';
import SinglePicker from '../common/controls/singlePicker';
import Icon from '../common/containers/icon';
import { removeItemWithConfirm } from '../common/classes/handleItemWithConfirm';
const AssetAssociationsAreas = ({
  onChange,
  areas,
  areaList
}) => {
  const handleChange = (index, value) => onChange(`areas[${index}]/id`, value);
  const handleRemoveArea = index => {
    const newAreas = JSON.parse(JSON.stringify(areas));
    newAreas.splice(index, 1);
    onChange('areas', newAreas);
  };
  const confirmOnRemoveFields = ['id'];
  const handleRemove = index => removeItemWithConfirm(areas[index], 'Area', confirmOnRemoveFields, handleRemoveArea.bind(null, index));
  const usedAreas = pluck(areas, 'id');
  return /*#__PURE__*/React.createElement("div", null, areas.map((area, index) => {
    const areaOptions = areaList.filter(a => a.id === area.id || !usedAreas.includes(a.id));
    return /*#__PURE__*/React.createElement("div", {
      key: area.id || uuidV4(),
      className: `t-aaa-${index}`
    }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      sm: {
        size: 6,
        offset: 3
      }
    }, /*#__PURE__*/React.createElement(SinglePicker, {
      label: "Associated Area",
      onChange: value => handleChange(index, value),
      options: areaOptions,
      placeholder: "Select...",
      value: area.id,
      returnValueKey: "id"
    })), /*#__PURE__*/React.createElement(Col, {
      sm: 3
    }, /*#__PURE__*/React.createElement("h5", {
      className: "text-input-custom-label"
    }, "\xA0"), /*#__PURE__*/React.createElement(Button, {
      size: "sm",
      onClick: () => handleRemove(index),
      className: "float-md-right form-control t-aaa-remove-area tqc-control"
    }, /*#__PURE__*/React.createElement(Icon, {
      glyph: "trash"
    }), " Remove Area"))));
  }));
};
AssetAssociationsAreas.propTypes = {
  areas: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  areaList: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onChange: PropTypes.func.isRequired
};
export default AssetAssociationsAreas;